/**
 * WordPress dependencies
 * @wordpress/i18n for translation functions
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 * - Should basically always be used for any text that is visible to the user
 *
 * @wordpress/element for React components
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-element/
 */
import { __ } from '@wordpress/i18n';
import { useSearchParams } from 'react-router-dom';

import FilterCheckbox from './FilterCheckbox';
/**
 * CourseListItem Component
 * @param {Object} props
 * @returns {JSX.Element}
 */
function CourseFilterItem({ type, values }) {
	const [searchParams, setSearchParams] = useSearchParams();

	return (
		<>
			<div className="course__filter-item">
				{Object.keys(values).map((key) => (
					<FilterCheckbox
						key={values[key].slug + '-' + values[key].id}
						id={values[key].id}
						type={type}
						label={values[key].name}
						slug={values[key].slug}
						searchParams={searchParams}
						setSearchParams={setSearchParams}
					/>
				))}
			</div>
		</>
	);
}

export default CourseFilterItem;
